import gsap from 'gsap';

export default class Marquee {
  constructor() {
    this.scroll = document.querySelector('.a-scroll');
    this.page = document.querySelector('.a-scroll > div');

    this.section = document.querySelector('.s-marquee');
    this.wrap = document.querySelector('.s-marquee-wrap');
    this.text = document.querySelector('.s-marquee .f-xl');

    this.width = this.text.clientWidth;

    this.offset = null;
  }

  inview = () => {
    this.wh = window.innerHeight;

    const { top, bottom } = this.wrap.getBoundingClientRect();

    this.offset = Math.abs((this.wrap.getBoundingClientRect().top - this.wh));

    if (top < window.innerHeight && bottom > 0) {
      this.transform();
    }
  }

  transform = () => {
    this.text.style.transform = `translate3d(-${this.offset / 2.5}px, 0, 0)`;
  }

  run = () => {
    this.inview();
  }

  destroy() {
    gsap.ticker.remove(this.run);
  }

  init = () => {
    gsap.ticker.add(this.run);
  }
}
